

















import Vue from "vue";
import { Toast } from "mint-ui";
import browsers from "@/utils/browsers";
const defaultMsg = "请在Android手机打开此页面";

export default Vue.extend({
  data() {
    return {
      isWeiXin: false,
    };
  },
  methods: {
    download() {
      var isPhone = /(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
      var isAndroid = "android" == browsers.isAndroidOrIOS();
      if (!isPhone || !isAndroid) {
        //移动端
        Toast(defaultMsg);
        return
      }
      if (browsers.isWeixin()) {
          this.isWeiXin = true
        return
      }
      window.location.href = "http://124.70.32.82:8788/apks/app-release.apk";
    },
    unmask() {
      this.isWeiXin = false
    }
  },
});
